import { HeartBitCore, SupportedChain } from '@fileverse/heartbit-core'
import { defaultNetwork } from '../../../config/network-config'

const networkId = defaultNetwork.networkId

export const heartbitCoreSDK = new HeartBitCore({
  chain: networkId as SupportedChain,
  rpcUrl: defaultNetwork.rpcUrl,
})
